var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ocr-form" },
    [
      _c("header", [
        _c("h1", { staticClass: "mb-2" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Espace de vérification")))
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "semibold fs-3 flex-level cpointer",
            on: { click: _vm.cancel }
          },
          [
            _c("i", { staticClass: "icon-arrow-back mr-1" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$l10n.__(
                    "Revenir à la liste des documents en attente de vérification"
                  )
                )
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-row jc-center ocr-form-container" },
        [
          !_vm.loading
            ? _c("div", { staticClass: "preview" }, [
                _vm.preview.mime === "application/pdf"
                  ? _c("embed", {
                      staticClass: "wp-10 block mt-4 mb-9",
                      attrs: { src: _vm.preview.url, type: "application/pdf" }
                    })
                  : _vm.preview.url
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "color26-bkg wp-10 block br mt-4 mb-9 py-4 px-6"
                      },
                      [
                        _c("img", {
                          staticClass: "wp-10 shadow br",
                          attrs: { src: _vm.preview.url }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "mb-6 ml-9",
                  attrs: {
                    "label-position": "top",
                    model: _vm.form,
                    rules: _vm.rules
                  }
                },
                [
                  _vm.errorCode
                    ? _c("div", { staticClass: "error-block p-2 br fs-3" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.errorLabel) +
                            "\n            "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.processing,
                          expression: "processing"
                        }
                      ],
                      staticClass: "prelative mb-6 ml-9 hp-5"
                    },
                    [_c("preloader", { attrs: { display: _vm.processing } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.processing,
                          expression: "!processing"
                        }
                      ],
                      staticClass: "collapse-infos bb-0",
                      model: {
                        value: _vm.activePanels,
                        callback: function($$v) {
                          _vm.activePanels = $$v
                        },
                        expression: "activePanels"
                      }
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { name: "document" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c(
                              "div",
                              { staticClass: "flex-level" },
                              [
                                _c("CompassIcon", {
                                  staticClass: "mr-3",
                                  attrs: {
                                    icon: "obj-slsy-document",
                                    size: "large"
                                  }
                                }),
                                _vm._v(" "),
                                _c("strong", { staticClass: "fs-4" }, [
                                  _vm._v(_vm._s(_vm.$l10n.__("Document")))
                                ])
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t.__(
                                  "ocr.OcrVerificationForm.supplier_name"
                                ),
                                prop: "supplier"
                              }
                            },
                            [
                              _c(
                                "autocomplete-remote-input",
                                {
                                  ref: "supplierSelect",
                                  attrs: {
                                    value: _vm.form.supplier,
                                    preset: _vm.presetSupplier,
                                    multiple: false,
                                    route: _vm.getAutocompleteRoute,
                                    placeholder: _vm.$t.__(
                                      "ocr.OcrVerificationForm.enter_supplier_name"
                                    ),
                                    "no-data-text": _vm.$t.__(
                                      "ocr.OcrVerificationForm.no_supplier_found"
                                    ),
                                    "query-parameters": { types: ["supplier"] },
                                    mode: "edit",
                                    "enable-add-action": _vm.canCreateSupplier,
                                    limit: 1
                                  },
                                  on: { input: _vm.updateSupplier }
                                },
                                [
                                  _vm.canCreateSupplier
                                    ? _c(
                                        "template",
                                        { slot: "addAction" },
                                        [
                                          _c("CompassButton", {
                                            staticClass: "ml-1",
                                            attrs: {
                                              label: _vm.remoteSupplier.length
                                                ? _vm.$t.__(
                                                    "ocr.OcrVerificationForm.create_supplier",
                                                    {
                                                      supplier:
                                                        _vm.remoteSupplier
                                                    }
                                                  )
                                                : _vm.$t.__(
                                                    "ocr.OcrVerificationForm.add_supplier"
                                                  ),
                                              type: "tertiary"
                                            },
                                            on: { click: _vm.addSupplier }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex-row" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "wp-3",
                                  attrs: {
                                    label: _vm.$t.__(
                                      "ocr.OcrVerificationForm.document_date"
                                    ),
                                    prop: "documentDate"
                                  }
                                },
                                [
                                  _c("date-input", {
                                    attrs: {
                                      mode: "edit",
                                      value: _vm.form.documentDate,
                                      format: _vm.formatDate
                                    },
                                    on: { input: _vm.updateDate }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "wp-3 ml-3",
                                  attrs: {
                                    label: _vm.$t.__(
                                      "common.labels.expected_close_date"
                                    ),
                                    prop: "dueDate"
                                  }
                                },
                                [
                                  _c("date-input", {
                                    attrs: {
                                      mode: "edit",
                                      value: _vm.form.dueDate,
                                      format: _vm.formatDate
                                    },
                                    on: { input: _vm.updateDueDate }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "wp-10",
                              attrs: {
                                id: "externalDocumentName",
                                label: _vm.$t.__(
                                  "ocr.OcrVerificationForm.external_supplier_document_number"
                                ),
                                prop: "externalDocumentName"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.externalDocumentName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "externalDocumentName",
                                      $$v
                                    )
                                  },
                                  expression: "form.externalDocumentName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex-row" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "wp-3",
                                  attrs: {
                                    label: _vm.$t.__("common.labels.currency"),
                                    prop: "currency"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "error",
                                        fn: function(ref) {
                                          var error = ref.error
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "el-form-item__error prelative"
                                              },
                                              [_vm._v(_vm._s(error))]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1744055006
                                  )
                                },
                                [
                                  _c("currency-input", {
                                    attrs: { mode: "symbol" },
                                    on: { input: _vm.updateCurrency },
                                    model: {
                                      value: _vm.form.currency,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "currency", $$v)
                                      },
                                      expression: "form.currency"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "ml-3 wp-3",
                                  attrs: {
                                    label: _vm.$t.__(
                                      "ocr.OcrVerificationForm.document_status"
                                    ),
                                    prop: "step"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      model: {
                                        value: _vm.form.step,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "step", $$v)
                                        },
                                        expression: "form.step"
                                      }
                                    },
                                    _vm._l(_vm.availableStep, function(step) {
                                      return _c("el-option", {
                                        key: step.value,
                                        attrs: {
                                          value: step.value,
                                          label: step.label
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "wp-6 ml-3",
                                  attrs: {
                                    label: _vm.$t.__("common.labels.smart_tags")
                                  }
                                },
                                [
                                  _c(
                                    "tags",
                                    {
                                      attrs: {
                                        linkedtype: _vm.linkedtype,
                                        options: _vm.defaultTags,
                                        edit: true,
                                        standalone: false,
                                        "fetch-tags": false
                                      },
                                      on: { tagsUpdated: _vm.tagsUpdated }
                                    },
                                    [
                                      _c("span", {
                                        attrs: { slot: "title" },
                                        slot: "title"
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.showNote
                        ? _c(
                            "p",
                            {
                              staticClass: "link",
                              on: {
                                click: function($event) {
                                  _vm.showNote = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Ajouter une note sur ce document"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        : _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t.__("common.labels.note") }
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea", rows: 6 },
                                model: {
                                  value: _vm.form.note,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "note", $$v)
                                  },
                                  expression: "form.note"
                                }
                              })
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _c(
                        "el-collapse-item",
                        { attrs: { name: "products" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c(
                              "div",
                              { staticClass: "flex-level" },
                              [
                                _c("CompassIcon", {
                                  staticClass: "mr-3",
                                  attrs: {
                                    icon: "obj-slsy-product",
                                    size: "large"
                                  }
                                }),
                                _vm._v(" "),
                                _c("strong", { staticClass: "fs-4" }, [
                                  _vm._v(
                                    _vm._s(_vm.$l10n.__("Produits & Services"))
                                  )
                                ])
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.form.products, function(product, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "mb-3" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex-row" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "wp-5",
                                        attrs: {
                                          label: _vm.$t.__(
                                            "common.labels.description"
                                          ),
                                          prop:
                                            "products." +
                                            index +
                                            ".description",
                                          rules: _vm.rulesLine.description
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "error",
                                              fn: function(ref) {
                                                var error = ref.error
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "el-form-item__error prelative"
                                                    },
                                                    [_vm._v(_vm._s(error))]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _c("el-input", {
                                          on: { input: _vm.updateDescription },
                                          model: {
                                            value: product.description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                product,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression: "product.description"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "wp-5 ml-3",
                                        attrs: {
                                          label: _vm.$t.__(
                                            "common.labels.accounting_code"
                                          ),
                                          prop:
                                            "products." +
                                            index +
                                            ".accountingCode",
                                          rules: _vm.rulesLine.accountingCode
                                        }
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "wp-10",
                                            attrs: {
                                              autocomplete: "off",
                                              filterable: "",
                                              placeholder: _vm.$t.__(
                                                "ocr.OcrVerificationForm.select_code"
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.setProductDescriptionLabel(
                                                  product
                                                )
                                              }
                                            },
                                            model: {
                                              value: product.accountingCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  product,
                                                  "accountingCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "product.accountingCode"
                                            }
                                          },
                                          _vm._l(_vm.accountingCodes, function(
                                            item
                                          ) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label:
                                                  item.code +
                                                  " - " +
                                                  item.label,
                                                value: item.id
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-row" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "wp-3 mb-1",
                                        attrs: {
                                          label: _vm.$t.__(
                                            "common.labels.amount_excluding_tax"
                                          ),
                                          prop:
                                            "products." +
                                            index +
                                            ".priceWithoutTax",
                                          rules: _vm.rulesLine.priceWithoutTax
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "error",
                                              fn: function(ref) {
                                                var error = ref.error
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "el-form-item__error prelative"
                                                    },
                                                    [_vm._v(_vm._s(error))]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _c("amount-masked-input", {
                                          attrs: { symbol: _vm.currencySymbol },
                                          on: {
                                            input: function($event) {
                                              _vm.hideDefaultValues()
                                              _vm.removeLineKeeper(index)
                                            }
                                          },
                                          model: {
                                            value: product.priceWithoutTax,
                                            callback: function($$v) {
                                              _vm.$set(
                                                product,
                                                "priceWithoutTax",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "product.priceWithoutTax"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "wp-3 ml-3 mb-1",
                                        attrs: {
                                          label: _vm.$t.__(
                                            "ocr.OcrVerificationForm.tax_rate"
                                          ),
                                          prop: "products." + index + ".tva",
                                          rules: _vm.rulesLine.tva
                                        }
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "wp-10",
                                            attrs: {
                                              autocomplete: "off",
                                              filterable: "",
                                              type: "number",
                                              placeholder: _vm.$t.__(
                                                "ocr.OcrVerificationForm.select_rate"
                                              )
                                            },
                                            model: {
                                              value: product.tva,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  product,
                                                  "tva",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "product.tva"
                                            }
                                          },
                                          _vm._l(_vm.tva, function(item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.label
                                                  ? item.rate +
                                                    "% - " +
                                                    item.label
                                                  : item.rate + "%",
                                                value: item.id
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "wp-3 ml-3 mb-1",
                                        attrs: {
                                          label: _vm.$t.__(
                                            "ocr.OcrVerificationForm.VAT_amount"
                                          ),
                                          prop:
                                            "products." + index + ".priceTva",
                                          rules: _vm.rulesLine.priceTva
                                        }
                                      },
                                      [
                                        _c("amount-masked-input", {
                                          attrs: { symbol: _vm.currencySymbol },
                                          on: {
                                            input: function($event) {
                                              _vm.hideDefaultValues()
                                              _vm.removeLineKeeper(index)
                                            }
                                          },
                                          model: {
                                            value: product.priceTva,
                                            callback: function($$v) {
                                              _vm.$set(product, "priceTva", $$v)
                                            },
                                            expression: "product.priceTva"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "wp-3 ml-3 mb-1",
                                        attrs: {
                                          label: _vm.$t.__(
                                            "common.labels.amount_including_tax"
                                          ),
                                          prop:
                                            "products." +
                                            index +
                                            ".priceWithTax",
                                          rules: _vm.rulesLine.priceWithTax
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "error",
                                              fn: function(ref) {
                                                var error = ref.error
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "el-form-item__error prelative"
                                                    },
                                                    [_vm._v(_vm._s(error))]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _c("amount-masked-input", {
                                          attrs: {
                                            value: _vm.getPriceTax(
                                              product,
                                              index
                                            ),
                                            symbol: _vm.currencySymbol
                                          },
                                          on: {
                                            input: function($event) {
                                              _vm.hideDefaultValues()
                                              _vm.setPriceTax(
                                                $event,
                                                product,
                                                index
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-row ai-center" },
                                  [
                                    index === _vm.form.products.length - 1
                                      ? _c("CompassButton", {
                                          staticClass: "b-0 pl-0",
                                          attrs: {
                                            label: _vm.$t.__(
                                              "ocr.OcrVerificationForm.add_line"
                                            ),
                                            type: "tertiary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.addProduct()
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex-item-right" },
                                      [
                                        index !== 0
                                          ? _c("CompassButton", {
                                              staticClass: "b-0 p-1",
                                              attrs: {
                                                label: _vm.$t.__(
                                                  "common.actions.delete"
                                                ),
                                                type: "tertiary-destructive"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteProduct(
                                                    index
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("CompassPlainButton", {
                                          attrs: {
                                            label: _vm.$t.__(
                                              "ocr.OcrVerificationForm.duplicate"
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.addProduct(product)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex-row" },
                            [
                              _c("p", { staticClass: "fs-4 semibold mt-0" }, [
                                _vm._v(_vm._s(_vm.$l10n.__("Total")))
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-form",
                                {
                                  staticClass: "flex-item-right wp-6",
                                  attrs: { "label-position": "left" }
                                },
                                [
                                  _c("el-form-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-row flex-right ai-center"
                                      },
                                      [
                                        _c("span", { staticClass: "gray-60" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$l10n.__("Montant total HT")
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("amount-masked-input", {
                                          staticClass: "w-120 ml-3",
                                          attrs: {
                                            value: _vm.getTotalWithoutTax,
                                            disabled: true,
                                            symbol: _vm.currencySymbol
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.getTvaRows, function(vatAmount) {
                                    return _c(
                                      "el-form-item",
                                      { key: vatAmount.id },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex-row flex-right ai-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "gray-60" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$l10n.__(
                                                      "Taux et montant TVA"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("el-input", {
                                              staticClass: "w-120 ml-3",
                                              attrs: {
                                                disabled: true,
                                                value: vatAmount.rate + "%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("amount-masked-input", {
                                              staticClass: "w-120 ml-2",
                                              attrs: {
                                                value: _vm.getTotalByTva(
                                                  vatAmount.id
                                                ),
                                                disabled: true,
                                                symbol: _vm.currencySymbol
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-form-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-row flex-right ai-center"
                                      },
                                      [
                                        _c("span", { staticClass: "gray-60" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$l10n.__("Montant total TTC")
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("amount-masked-input", {
                                          staticClass: "w-120 ml-3",
                                          attrs: {
                                            value: _vm.getTotalWithTax,
                                            disabled: true,
                                            symbol: _vm.currencySymbol
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.canAddPayment
                        ? _c(
                            "el-collapse-item",
                            { attrs: { name: "payment" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "div",
                                  { staticClass: "flex-level" },
                                  [
                                    _c("CompassIcon", {
                                      staticClass: "mr-3",
                                      attrs: {
                                        icon: "obj-slsy-payment",
                                        size: "large"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("strong", { staticClass: "fs-4" }, [
                                      _vm._v(
                                        _vm._s(_vm.$l10n.__("Le paiement"))
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.form.payments, function(
                                payment,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "mb-4" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex-row" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "wp-3",
                                            attrs: {
                                              label: _vm.$t.__(
                                                "ocr.OcrVerificationForm.payment_date"
                                              ),
                                              rules: _vm.getPaymentRules(
                                                payment
                                              ).date,
                                              prop:
                                                "payments." + index + ".date"
                                            }
                                          },
                                          [
                                            _c("date-input", {
                                              attrs: { mode: "edit" },
                                              model: {
                                                value: payment.date,
                                                callback: function($$v) {
                                                  _vm.$set(payment, "date", $$v)
                                                },
                                                expression: "payment.date"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "wp-7 ml-3",
                                            attrs: {
                                              label: _vm.$t.__(
                                                "ocr.OcrVerificationForm.payment_reference"
                                              ),
                                              rules: _vm.getPaymentRules(
                                                payment
                                              ).reference,
                                              prop:
                                                "payments." +
                                                index +
                                                ".reference"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              model: {
                                                value: payment.reference,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    payment,
                                                    "reference",
                                                    $$v
                                                  )
                                                },
                                                expression: "payment.reference"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex-row" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "wp-3",
                                            attrs: {
                                              label: _vm.$t.__(
                                                "common.labels.amount"
                                              ),
                                              rules: _vm.getPaymentRules(
                                                payment
                                              ).amount,
                                              prop:
                                                "payments." + index + ".amount"
                                            }
                                          },
                                          [
                                            _c("amount-masked-input", {
                                              attrs: {
                                                symbol: _vm.currencySymbol
                                              },
                                              model: {
                                                value: payment.amount,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    payment,
                                                    "amount",
                                                    $$v
                                                  )
                                                },
                                                expression: "payment.amount"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "wp-7 ml-3",
                                            attrs: {
                                              label: _vm.$t.__(
                                                "common.labels.payment_method"
                                              ),
                                              rules: _vm.getPaymentRules(
                                                payment
                                              ).payment_mean,
                                              prop:
                                                "payments." +
                                                index +
                                                ".payment_mean"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "wp-10",
                                                attrs: {
                                                  autocomplete: "off",
                                                  filterable: "",
                                                  clearable: "",
                                                  placeholder: _vm.$t.__(
                                                    "ocr.OcrVerificationForm.select_payment_method"
                                                  )
                                                },
                                                model: {
                                                  value: payment.payment_mean,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      payment,
                                                      "payment_mean",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "payment.payment_mean"
                                                }
                                              },
                                              _vm._l(_vm.paymentTypes, function(
                                                item
                                              ) {
                                                return _c("el-option", {
                                                  key: item.id,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.id
                                                  }
                                                })
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex-row" },
                                      [
                                        index === _vm.form.payments.length - 1
                                          ? _c("CompassButton", {
                                              staticClass: "pl-0 b-0",
                                              attrs: {
                                                label: _vm.$t.__(
                                                  "ocr.OcrVerificationForm.add_payment"
                                                ),
                                                type: "tertiary"
                                              },
                                              on: { click: _vm.addPayment }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        index !== 0
                                          ? _c("CompassButton", {
                                              staticClass:
                                                "flex-item-right b-0 p-1",
                                              attrs: {
                                                label: _vm.$t.__(
                                                  "common.actions.delete"
                                                ),
                                                type: "tertiary-destructive"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deletePayment(
                                                    index
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pfixed py-3 px-4 white-bkg footer" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "mx-auto flex-row flex-right ai-center"
                        },
                        [
                          _vm.multipleVerify
                            ? _c(
                                "p",
                                { staticClass: "flex-item-left m-0 fs-3" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Nombre de documents restant à vérifier :"
                                        )
                                      ) +
                                      "\n                        " +
                                      _vm._s(_vm.ocrRows.length - 1) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__(
                                "ocr.OcrVerificationForm.delete_document"
                              ),
                              type: "tertiary-destructive"
                            },
                            on: {
                              click: function($event) {
                                return _vm.deleteOCR()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassButton", {
                            staticClass: "ml-3",
                            attrs: {
                              label: _vm.$t.__(
                                "ocr.OcrVerificationForm.ignore_document"
                              ),
                              type: "secondary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.skip()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassButton", {
                            staticClass: "ml-3",
                            attrs: {
                              "native-type": "button",
                              label: _vm.$t.__("common.actions.validate"),
                              type: "primary"
                            },
                            on: { click: _vm.submit }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }